import { OptionButton } from './OptionButton'
import type { YesNoPage } from '@/content/quiz/types'
import { SocialProofBlock } from './SocialProofBlock'

interface YesNoQuestionProps {
  page: YesNoPage
  value?: string
  onSelect: (value: string) => void
}

export function YesNoQuestion({ page, value, onSelect }: YesNoQuestionProps) {
  return (
    <div className="space-y-6 flex flex-col items-center">
      <h2 className="text-xl font-semibold text-slate-900 text-center">{page.question}</h2>
      <div className="grid grid-cols-2 gap-2 w-full">
        {page.options.map((option) => (
          <OptionButton
            key={option.value}
            option={option}
            selected={value === option.value}
            onClick={() => onSelect(option.value)}
            variant="large"
          />
        ))}
      </div>
      {page.socialProof && (
        <SocialProofBlock config={page.socialProof} className="mt-8" />
      )}
    </div>
  )
}
